import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { ReactComponent as BaseXSign } from '../../assets/compliance-no.svg';
import { ReactComponent as BaseVSign } from '../../assets/BookingBoard/confirmed-big.svg';
import { ReactComponent as BaseErrorSign } from '../../assets/error.svg';
import { Tooltip } from '../Tooltip';

const ErrorSign = styled(BaseErrorSign)`
  > path {
    fill: ${({ theme }) => theme.colors.redNegative};
  }
`;

const XSign = styled(BaseXSign)`
  width: 20px;
  height: 20px;

  path:first-of-type {
    fill: ${({ theme }) => theme.colors.redNegative};
    transform: scale(1.25); /* Adjust scale to fill the 20x20 space */
    transform-origin: center;
  }
`;

const VSign = styled(BaseVSign)`
  height: 20px;
  width: 20px;
`;

const CheckedRenderer = ({
  rowData = {},
  dataKey,
  columnData: { value: defaultValue, tooltip } = {},
  showFalse = false,
  showTooltipForFalse = false,
  showDashSignForFalse = false
}) => {
  const value = get(rowData, dataKey);

  if (rowData.summarized || rowData.subRows) {
    return <></>;
  }

  return defaultValue || value ? (
    <Tooltip body={tooltip} disabled={!tooltip}>
      <VSign />
    </Tooltip>
  ) : (
    <>
      {showFalse &&
        (showTooltipForFalse ? (
          <Tooltip body={tooltip} disabled={!tooltip}>
            {showDashSignForFalse ? ' - ' : <XSign />}
          </Tooltip>
        ) : (
          <>{showDashSignForFalse ? ' - ' : <ErrorSign />}</>
        ))}
    </>
  );
};

export default CheckedRenderer;
